import {
  ArticleOutlined,
  AssessmentOutlined,
  AutoAwesomeOutlined,
  BusinessOutlined,
  DashboardCustomizeOutlined,
  DashboardOutlined,
  EventRepeatOutlined,
  HomeOutlined,
  PeopleAltOutlined,
} from '@mui/icons-material'
import { SvgIconProps } from '@mui/material'
import { ReactElement } from 'react'

interface SidebarItemProp {
  idn: string
  icon: ReactElement<SvgIconProps>
  label: string
  route: string
  workspace?: boolean
  notInProd?: boolean
  featureFlag?: 'insights'
  adminOnly?: boolean
}

const SELLER_ICONS: SidebarItemProp[] = [
  {
    idn: '999',
    icon: <HomeOutlined />,
    label: 'Página Inicial',
    route: '/home',
  },
  {
    idn: '998',
    icon: <DashboardOutlined />,
    label: 'Dashboard',
    route: '/dashboard',
  },
  {
    idn: '997',
    icon: <AssessmentOutlined sx={{ transform: 'rotate(90deg)' }} />,
    label: 'Tarefas',
    route: '/control-pannel',
    notInProd: true,
  },
  {
    idn: '996',
    icon: <BusinessOutlined />,
    label: 'Clientes',
    route: '/customers',
    workspace: true,
  },
  // Insights desabilitado no menu do seller: o seletor de workspaces lista
  // todos os buyers da corretora, mas so o buyer piloto tem dados no Snowflake.
  // Reativar quando GET /insights/workspaces filtrar por buyer habilitado.
  // {
  //   idn: '993',
  //   icon: <AutoAwesomeOutlined />,
  //   label: 'Insights',
  //   route: '/insights',
  //   featureFlag: 'insights',
  // },
  {
    idn: '995',
    icon: <DashboardCustomizeOutlined />,
    label: 'Loja',
    route: '/store',
  },
]

const BUYER_ICONS: SidebarItemProp[] = [
  {
    idn: '999',
    icon: <HomeOutlined />,
    label: 'Página Inicial',
    route: '/home',
  },
  {
    idn: '998',
    icon: <DashboardOutlined />,
    label: 'Dashboard',
    route: '/dashboard',
  },
  {
    idn: '994',
    icon: <PeopleAltOutlined />,
    label: 'Colaboradores',
    route: '/collaborators',
  },
  {
    idn: '997',
    icon: <AssessmentOutlined sx={{ transform: 'rotate(180deg)' }} />,
    label: 'Tarefas',
    route: '/control-pannel',
    notInProd: true,
  },
  {
    idn: '996',
    icon: <ArticleOutlined />,
    label: 'Contratos',
    route: '/customers',
    workspace: true,
  },
  {
    idn: '993',
    icon: <AutoAwesomeOutlined />,
    label: 'Insights',
    route: '/insights',
    featureFlag: 'insights',
  },
  {
    idn: '995',
    icon: <DashboardCustomizeOutlined />,
    label: 'Loja',
    route: '/store',
  },
  {
    idn: '992',
    icon: <EventRepeatOutlined />,
    label: 'Rotinas',
    route: '/v2/painel-operacional',
    adminOnly: true,
  },
]

export { BUYER_ICONS, SELLER_ICONS }
